/**
 * Size distribution of a shipment line (mirrors SalesOrderItemBreakdown / 0108).
 * Path: org/{orgId}/shipment/{shipmentId}/item/{itemId}/breakdown
 *
 * `lotId` is set at ship time (manual allocation — FEFO is follow-up).
 */
export const SHIPMENT_ITEM_BREAKDOWN = 'ShipmentItemBreakdown';
//# sourceMappingURL=shipment-item-breakdown.js.map